<template>
  <div>
    <BaseUploadExcel
      ref="baseUploadExcel"
      :headers="headers"
      :xlsxFileSchema="xlsxFileSchema"
      :openOut="true"
      @onUploadSuccess="onUploadSuccess"
      :isUseOriginTable="false"
    >
      <v-list>
        <v-list-item
          v-if="$auth.policies['import-checks:update-product'] && selectAuditProduct.statusOrder === 'open'"
          @click="uploadFile"
          class="pointer item1"
          >Tải lên file (Excel)</v-list-item
        >
        <v-list-item @click="downloadFile" class="pointer item2">Tải xuống file (Excel)</v-list-item>
      </v-list>
    </BaseUploadExcel>
    <PopupPreviewUploadExcel ref="popupPreviewData" :headers="headers" @accept="accept" @cancel="cancel" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { get, unset } from 'lodash'
import moment from 'moment'
import api from '@/plugins/api'
import utils from '@/plugins/utils'
import { formatDateDDMMYYYY } from '@/helpers/date.js'
import BaseUploadExcel from '@/components/samnec/base-upload-excel/BaseUploadExcel.vue'
import PopupPreviewUploadExcel from './PopupPreviewUploadExcel.vue'

export default {
  components: { BaseUploadExcel, PopupPreviewUploadExcel },
  data() {
    return {
      headers: [
        { text: 'Model', value: 'code' },
        { text: 'Mô tả', value: 'description' },
        { text: 'Mã IMEI / Mã Seria', value: 'imei' },
        { text: 'Mã hoá đơn', value: 'billCode' },
        { text: 'Mã phiếu / DO', value: 'doCode' },
        { text: 'Mã đơn / PO', value: 'poCode' },
        { text: 'Đạt tiêu chuẩn / xác nhận nhập (0: Không đạt, 1: Đạt)', value: 'status' },
        { text: 'Ngày nhập thực tế', value: 'deliveredAt' },
        { text: 'Ghi chú', value: 'notes' }
      ],
      xlsxFileSchema: {
        Model: { prop: 'code', type: String },
        'Mô tả': { prop: 'description', type: String },
        'Mã IMEI / Mã Seria': { prop: 'imei', type: String },
        'Mã hoá đơn': { prop: 'billCode', type: String },
        'Mã phiếu / DO': { prop: 'doCode', type: String },
        'Mã đơn / PO': { prop: 'poCode', type: String },
        'Đạt tiêu chuẩn / xác nhận nhập (0: Không đạt, 1: Đạt)': { prop: 'status', type: String },
        'Ngày nhập thực tế': { prop: 'deliveredAt', type: String },
        'Ghi chú': { prop: 'notes', type: String }
      }
    }
  },
  computed: {
    ...mapState({
      selectAuditProduct(state) {
        return state['auditProducts'].item
      }
    })
  },
  methods: {
    ...mapActions({
      getImportDeliveryProduct: 'auditProducts/getImportDeliveryProduct',
      updateManyItems: 'auditProducts/updateManyItems'
    }),
    async downloadFile() {
      try {
        this.$loading.active = true
        let res = await api['AuditProducts'].getImportDeliveryProduct({
          importCheck: get(this.selectAuditProduct, 'id'),
          _start: 0,
          _sort: 'createdAt:DESC'
        })
        res.forEach(item => {
          item.deliveredAt = formatDateDDMMYYYY(item.deliveredAt)
          item.status = item.status === 'approve' ? '1' : '0'
        })
        utils.exportExcel(
          res,
          [
            { text: 'Model', value: 'code' },
            { text: 'Mô tả', value: 'description' },
            { text: 'Mã IMEI / Mã Seria', value: 'imei' },
            { text: 'Mã hoá đơn', value: 'billCode' },
            { text: 'Mã phiếu / DO', value: 'doCode' },
            { text: 'Mã đơn / PO', value: 'poCode' },
            { text: 'Đạt tiêu chuẩn / xác nhận nhập (0: Không đạt, 1: Đạt)', value: 'status' },
            { text: 'Ngày nhập thực tế', value: 'deliveredAt' },
            { text: 'Ghi chú', value: 'notes' }
          ],
          `${get(this.selectAuditProduct, 'importOrderCode', '')} - Kiểm hàng theo Đơn hàng nhập ${get(
            this.selectAuditProduct,
            'productIndustry.name',
            ''
          )} / ${get(this.selectAuditProduct, 'producer.name', '')} / ${get(
            this.selectAuditProduct,
            'productType.name',
            ''
          )} ${
            this.selectAuditProduct.deliveredAt
              ? `- Ngày ` + moment(new Date(this.selectAuditProduct.deliveredAt)).format('DD/MM/YYYY')
              : ''
          }`
        )
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    async onUploadSuccess(data) {
      try {
        this.$loading.active = true
        const res = await api['ImportDeliveryProduct'].fetch({
          importCheck: get(this.selectAuditProduct, 'id'),
          code_in: data.map(item => item.code)
        })
        const mapData = data.map(item => {
          const productExist = res.find(resItem => resItem.code === item.code && resItem.imei === item.imei)
          return {
            ...item,
            deliveredAt: item.deliveredAt ? moment(item.deliveredAt, 'DD/MM/YYYY').format('DD/MM/YYYY') : '',
            error: !productExist
          }
        })
        this.$refs['popupPreviewData'].openDialog(mapData)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    async accept({ val }) {
      try {
        this.$loading.active = true
        const data = val.map(item => {
          unset(item, 'error')
          const formatDate = moment(item.deliveredAt, 'DD/MM/YYYY')
          return {
            ...item,
            // eslint-disable-next-line
            status: item.status == '1' ? 'approve' : 'reject',
            deliveredAt: formatDate.toISOString()
          }
        })
        await this.updateManyItems({
          importCheck: get(this.selectAuditProduct, 'id'),
          productList: data
        })
        this.$alert.success('Upload file thành công')
        this.$emit('refresh')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.$refs['baseUploadExcel'].cancel()
    },
    uploadFile() {
      this.$refs['baseUploadExcel'].onUpload()
    }
  },
  watch: {}
}
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.item1:hover {
  background-color: rgb(226, 226, 226);
}
.item2:hover {
  background-color: rgb(226, 226, 226);
}
</style>
